import Cookie from 'js-cookie';
import { requestService } from './utils';

export function getHeaders() {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': Cookie.get('csrf'),
  };
}

export const fetchActiveLisitngsSearchResults = (str, page = 1) => {
  return requestService('/api/v1/store_product_templates', {
    method: 'get',
    headers: getHeaders(),
    params: {
      includeMetadata: true,
      includeTotalCount: true,
      page: page,
      query: str,
    },
  }).then((response) => {
    return response;
  });
};

export const fetchConfirmSearchResults = (str, page = 1) => {
  return requestService('/api/v1/orders', {
    method: 'get',
    headers: getHeaders(),
    params: { filter: 'to_confirm', page: page, query: str },
  }).then((response) => {
    return response;
  });
};

export const fetchToShipSearchResults = (str, page = 1) => {
  return requestService('/api/v1/orders', {
    method: 'get',
    headers: getHeaders(),
    params: { filter: 'dropship_need_to_ship', page: page, query: str },
  }).then((response) => {
    return response;
  });
};

export const fetchShippedSearchResults = (str, page = 1) => {
  return requestService('/api/v1/orders', {
    method: 'get',
    headers: getHeaders(),
    params: { filter: 'dropship_seller_shipped', page: page, query: str },
  }).then((response) => {
    return response;
  });
};

export const fetchOpenSearchResults = (str, page = 1) => {
  return requestService('/api/v1/orders', {
    method: 'get',
    headers: getHeaders(),
    params: { filter: 'dropship_open', page: page, query: str },
  }).then((response) => {
    return response;
  });
};

export const fetchDeliveredSearchResults = (str, page = 1) => {
  return requestService('/api/v1/orders', {
    method: 'get',
    headers: getHeaders(),
    params: { filter: 'delivered', page: page, query: str },
  }).then((response) => {
    return response;
  });
};

export const fetchReturnedSearchResults = (str, page = 1) => {
  return requestService('/api/v1/orders', {
    method: 'get',
    headers: getHeaders(),
    params: { filter: 'returned', page: page, query: str },
  }).then((response) => {
    return response;
  });
};

export const fetchCanceledSearchResults = (str, page = 1) => {
  return requestService('/api/v1/orders', {
    method: 'get',
    headers: getHeaders(),
    params: { filter: 'canceled', page: page, query: str },
  }).then((response) => {
    return response;
  });
};

export const fetchCompletedSearchResults = (str, page = 1) => {
  return requestService('/api/v1/orders', {
    method: 'get',
    headers: getHeaders(),
    params: { filter: 'completed', page: page, query: str },
  }).then((response) => {
    return response;
  });
};
